import { BranchDetailOutput } from './branch-detail-output.model';


export class BranchDetailSelectByIdOutput implements IBranchDetailSelectByIdOutput {
    status!: number;
    message!: string;
    data!: BranchDetailOutput;

    constructor(data?: IBranchDetailSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? BranchDetailOutput.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): BranchDetailSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BranchDetailSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IBranchDetailSelectByIdOutput {
    status: number;
    message: string;
    data: BranchDetailOutput;
}

